import { PowerBIReport } from '@features/reports/PowerBiReport'
import { ReportLink, ReportLinks } from '@features/reports/ReportLinks'
import { ReportsLayout } from '@features/reports/ReportsLayout'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/reports/destinations')({
  component: RouteComponent,
})

function RouteComponent() {
    const links: ReportLink[] = [
        { name: 'Hesa', link: 'https://godalmingacuk.sharepoint.com/sites/StaffPortal/Reporting/Forms/AllItems.aspx?id=%2Fsites%2FStaffPortal%2FReporting%2FHESA&viewid=092db772%2D314f%2D4bba%2D8929%2Da24b2ed920ca&npsAction=createList&ovuser=72932ce3%2D5a2e%2D41c6%2D9bf8%2Dc843ff65c653%2CGED%40godalming%2Eac%2Euk&OR=Teams%2DHL&CT=1754298839975&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNTA3MDMxODgwOSIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D' },
        { name: 'Work Experience Data', link: 'https://godalmingacuk.sharepoint.com/sites/StaffPortal/Reporting/Forms/AllItems.aspx?id=%2Fsites%2FStaffPortal%2FReporting%2FWork%20Experience%20Data&viewid=092db772%2D314f%2D4bba%2D8929%2Da24b2ed920ca&npsAction=createList&ovuser=72932ce3%2D5a2e%2D41c6%2D9bf8%2Dc843ff65c653%2CGED%40godalming%2Eac%2Euk&OR=Teams%2DHL&CT=1754298839975&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNTA3MDMxODgwOSIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D' }
    ]
        
  return (
    <ReportsLayout>
        <PowerBIReport reportId='bd5de076-e4b2-41e3-8cff-c2ce84ab17d9'/>
        <ReportLinks links={links}/>
    </ReportsLayout>

  )
}
